import React from "react";

import { WizardPage } from "./WizardPage";

export const MultipleWizardPage = (props) => (
  <WizardPage {...props} isSingle={false} />
);
